import axios from 'axios';
import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import SelectDown from 'react-dropdown-select';
import EditorComponent from './Template/Editor';
import services from '../services';
import DOMPurify from 'dompurify';
import { emailReply } from '../Redux/slice';
import { useDispatch } from 'react-redux';
import ComposeEmail from './composeEmail/ComposeEmail';
import { FormControl, Select, MenuItem } from '@mui/material';
import { Tooltip } from 'react-tooltip';
import Loading from '../utils/Loading';
import ReplyDropdown from '../common/ReplyDropdown';
import email from '../services/email';
const MailInbox = ({
    selectedEmailData,
    dataById,
    setgetEmailData,
    getemailbyid,
    formattedBody,
    setFormattedBody,
    mailContent,
    setMailContent,
    handlegetEmailDetails,
    attachmentPaths,
    decodeHtml,
    threadData,
    loading,
    showSeletedThreadMail,
    setLoading,
    selectedEmailId,
    childTaskData,
    setCurrentTask,
    selectedMail,
    TaskId
}) => {
    const [emailValue, setEmailValue] = React.useState(() => {
        return selectedMail?.labels?.includes('SENT')
            ? selectedMail?.sentTo?.split('"').filter(Boolean)[0] ||
            selectedMail?.Email?.sentTo?.split('"').filter(Boolean) ||
            childTaskData?.Email?.sentTo?.split('"').filter(Boolean) ||
            ''
            : selectedMail?.sentBy?.split('"').filter(Boolean) ||
            selectedMail?.Email?.sentBy?.split('"').filter(Boolean) ||
            childTaskData?.Email?.sentBy?.split('"').filter(Boolean) ||
            '';
    });
    const [submitData, setSubmitData] = useState('')
    React.useEffect(() => {
        setEmailValue(
            selectedMail?.labels?.includes('SENT')
                ? selectedMail?.sentTo?.split('"').filter(Boolean)[0] ||
                selectedMail?.Email?.sentTo?.split('"').filter(Boolean) ||
                childTaskData?.Email?.sentTo?.split('"').filter(Boolean) ||
                ''
                : selectedMail?.sentBy?.split('"').filter(Boolean) ||
                selectedMail?.Email?.sentBy?.split('"').filter(Boolean) ||
                childTaskData?.Email?.sentBy?.split('"').filter(Boolean) ||
                ''
        );
    }, [selectedMail, childTaskData]);


    const [textAreaValue, setTextAreaValue] = useState('');
    const location = useLocation();
    const [replyDropdown, setReplyDropdown] = useState(false);
    const [replyDropdown1, setReplyDropdown1] = useState(false);
    const [replyDropdown2, setReplyDropdown2] = React.useState([false, false, false]);

    const [replyDropdown3, setReplyDropdown3] = useState(false);
    const [showMoreOptions, setShowMoreOptions] = useState(false);
    const [openModalId, setOpenModalId] = useState(null);
    const dropdownRefs = useRef({});

    useEffect(() => {
        const handleClickOutside = (event) => {
            // Handle openModalId dropdowns
            if (openModalId) {
                const currentRef = dropdownRefs.current[openModalId];
                if (currentRef && !currentRef.contains(event.target)) {
                    setOpenModalId(null);
                }
            }

            // Handle main email dropdown
            if (showMoreOptions && !event.target.closest('.more-options-container')) {
                setShowMoreOptions(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [openModalId, showMoreOptions]);
    // Close more options menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (Object.values(showMoreOptions).some(isOpen => isOpen) && !event.target.closest('.more-options-container')) {
                setShowMoreOptions({});
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [showMoreOptions]);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [isSearchBoxOpen, setIsSearchBoxOpen] = useState(false);
    const [assignedUserName, setAssignedUserName] = useState('');

    // const [formattedBody, setFormattedBody] = useState([]);
    const [allTemp, setAllTemp] = useState([]);
    const [cc, setCc] = useState("");
    const [bcc, setBcc] = useState("")
    const [thread, setThread] = useState('');
    const [showCc, setShowCc] = useState(false);
    const [showBcc, setShowBcc] = useState(false);
    const [showBccCc, setShowBccCc] = useState(false)
    const [isForward, setIsForward] = useState(false)
    const [isreplyAll, setIsreplyAll] = useState(false)
    const [isvisible, setIsvisible] = useState(false)
    // const [mailContent, setMailContent] = useState('');
    const [composeStatus, setComposeStatus] = useState(false);

    const [templateselect, setTemplateselect] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [taskAssign, setTaskAssign] = useState([]);
    const [allThreadTask, setAllThreadTask] = useState([]);
    const [selectedThread, setSelectedThread] = useState(null);

    const [template, setTemplate] = useState({
        templateData: '',
    });
    const [draftStatus, setDraftStatus] = useState(false);
    const [saveDrafts, setSaveDrafts] = useState()
    const [draftId, setDraftId] = useState(null);

    const dispatch = useDispatch();
    // const selectedMail = location.state?.selectedMail ? location.state?.selectedMail : selectedEmailData;
    const navigate = useNavigate();
    const filteredUsers = taskAssign.filter((user) => user.name.toLowerCase().includes(searchTerm.toLowerCase()));

    const [currentMailIndex, setCurrentMailIndex] = useState(0);

    // Add new state to track which specific submail's thread is being shown
    const [expandedThreadIndex, setExpandedThreadIndex] = useState(null);
    const [expandreplyVisible, setExpandreplyVisible] = useState(null)

    const handleEmailChange = (e) => {
        setEmailValue(e.target.value);
        setShowBccCc(true)
    };
    const handleCcChange = (e) => {
        setCc(e.target.value)
    }
    const handleBccChange = (e) => {
        setBcc(e.target.value)
    }


    const handleTextAreaChange = (event) => {
        setTextAreaValue(event.target.value);
    };

    const handleToggleSearchBox = () => {
        setIsSearchBoxOpen(!isSearchBoxOpen);
    };

    const handlebackbutton = () => {
        navigate('/app');
    };

    const handleDelete = (mode = 'replyAll', idx = null) => {
        setExpandreplyVisible(idx)
        if (mode === 'replyAll') {
            setReplyDropdown1(false)
            setReplyDropdown2(false)
            setReplyDropdown3(false)
        } else if (mode === 'visible') {
            // setReplyDropdown2((prev) => {
            //     const newState = [...prev];
            //     if (idx !== null && idx >= 0) {
            //         newState[idx] = !newState[idx];
            //     }
            //     return newState;
            // });
            setReplyDropdown2(!replyDropdown2)
            setReplyDropdown1(false)
            setReplyDropdown3(false)
        }
        else if (mode === '-') {
            setReplyDropdown3(false)
            setReplyDropdown1(false)
            setReplyDropdown2(false)
        }
        setReplyDropdown(false)
        setEmailValue('')
        setCc('')
        setBcc('')

    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            updateTaskMail(selectedMail?.id);
        }
    };
    const [isReply, setIsReply] = useState(false)

    const handlereply = (mode = 'replyAll', idx, item) => {
        setIsReply(true)
        setIsForward(false)
        setExpandreplyVisible(idx)
        if (mode === 'replyAll') {
            setIsreplyAll(true);
            setIsvisible(false);

            setReplyDropdown1(!replyDropdown1);
            setReplyDropdown2(false)
            setReplyDropdown3(false)
        } else if (mode === 'visible') {
            setIsvisible(true);
            setIsreplyAll(false);

            // setReplyDropdown2((prev) => {
            //     const newState = [...prev];
            //     if (idx !== null && idx >= 0) {
            //         newState[idx] = !newState[idx];
            //     }
            //     return newState;
            // });
            setReplyDropdown2(!replyDropdown2)
            setReplyDropdown1(false)
            setReplyDropdown3(false)
        } else if (mode === '-') {
            setReplyDropdown3(!replyDropdown3);
            setReplyDropdown1(false)
            setReplyDropdown2(false)
        }
        const userData = JSON.parse(localStorage.getItem("userData") || "{}");
        const currentUserEmail = userData?.email || "";
        const extractEmails = (str) => {
            if (!str) return [];
            return str.match(/[\w.-]+@[\w.-]+\.[A-Za-z]{2,}/g) || [];
        };

        let setReply;

        if (mode === 'replyAll') {

            setReply = emailValue;
            setEmailValue(emailValue)

        } else
            if (mode === 'visible') {

                setReply = item;
                const extractEmailOnly = (str) => {
                    if (!str) return '';
                    const emailMatch = str.match(/<(.+)>/);
                    if (emailMatch && emailMatch[1]) {
                        return emailMatch[1].trim();
                    }

                    return str.trim();
                };
                const ccList = item.cc ? item.cc.split(',').map(email => email.trim()) : [];
                const bccList = item.bcc ? item.bcc.split(',').map(email => email.trim()) : [];

                const ccBccList = [...ccList, ...bccList];
                const sentToEmail = extractEmailOnly(selectedMail.sentTo );
                const isMatched = ccBccList.includes(sentToEmail);

                const toRecipients = extractEmails(setReply?.sentTo || setReply?.[recipientField])
                    .filter(r => r !== currentUserEmail);
                setEmailValue(toRecipients.join(', '));
            } else if (mode === '-') {

                setReply = lastReplyBody || selectedMail || selectedMail?.Email || childTaskData?.Email
                let recipientField;

                if (lastReplyBody) {

                    recipientField = lastReplyBody?.labels?.includes('API-Reply') || lastReplyBody?.labels?.includes('API-Forward') || isMatched ? 'receiver' : 'sender'

                } else {

                    recipientField = selectedMail?.labels?.includes('SENT') ? 'sentTo' : 'sentBy';
                }
                const toRecipients = extractEmails(setReply?.[recipientField] || setReply?.receiver)
                    .filter(r => r !== currentUserEmail);

                setEmailValue(toRecipients.join(', '));
            } else {

            }

        // setReplyDropdown(!replyDropdown);
        setIsForward(false);
        setCc("");
        setBcc("");
    };

    const handleForward = (mode = 'replyAll', idx = null) => {
        setExpandreplyVisible(idx)

        setIsForward(true);
        setIsReply(false)
        setEmailValue(null)
        if (mode === 'replyAll') {
            setReplyDropdown1(!replyDropdown1)
            setReplyDropdown2(false)
            setReplyDropdown3(false)
        }
        else if (mode === 'visible') {
            // setReplyDropdown2((prev) => {
            //     const newState = [...prev];
            //     if (idx !== null && idx >= 0) {
            //         newState[idx] = !newState[idx];
            //     }
            //     return newState;
            // });
            setReplyDropdown2(!replyDropdown2)
            setReplyDropdown1(false)
            setReplyDropdown3(false)
        } else if (mode === '-') {
            setReplyDropdown3(!replyDropdown3)
            setReplyDropdown1(false)
            setReplyDropdown2(false)
        }
        setReplyDropdown(!replyDropdown)
    }

    const handleUserSelect = async (user) => {
        setSelectedUserId(user?.id);
        setSearchTerm(user?.name);

        try {
            await updateTaskMail(selectedMail?.id);
            setIsSearchBoxOpen(false);
            // setAssignedUserName(user?.name);
            toast.success('Task assigned successfully!');
        } catch (error) {
            toast.error('Failed to assign task. Please try again.');
            console.error('Error assigning task:', error);
        }
    };

    const getTaskAssign = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/auth/getAllUser?limit=10&email=${searchTerm}`,
            );
            if (response) {
                setTaskAssign(response?.data?.data?.users);
            }
        } catch (error) {
            console.error('Error fetching task mails:', error);
        }
    };

    const buildDraftFormData = () => {
        const formData = new FormData();

        const { gmailMessageId, sentBy, sentTo, Email, subject, gmailUserId, id } =
            selectedMail == null ? childTaskData : selectedMail || getemailbyid || childTaskData?.Email;

        const senderEmail = (
            (sentTo && sentTo.match(/<([^>]+)>/)?.[1]) ||
            Email?.sentTo?.match(/<([^>]+)>/)?.[1] ||
            sentTo ||
            Email?.sentTo
        )?.trim();

        const receiverEmail = (
            (sentBy && sentBy.match(/<([^>]+)>/)?.[1]) ||
            Email?.sentBy?.match(/<([^>]+)>/)?.[1] ||
            sentBy ||
            Email?.sentBy
        )?.trim();



        let decodedHTML = textAreaValue
            .replace(/&lt;/g, "<")
            .replace(/&gt;/g, ">")
            .replace(/&nbsp;/gi, " ")
            .replace(/&amp;/gi, "&");

        let plainText = decodedHTML
            .replace(/<p[^>]*>/gi, "")
            .replace(/<\/p>/gi, "\n")
            .replace(/\r\n|\r/g, "\n")
            .split("\n")
            .map((line) => line.trim())
            .filter((line) => line.length > 0)
            .join("\n");

        let lines = plainText.split("\n");
        if (lines.length > 1 && lines[0].trim() !== "") {
            lines.splice(1, 0, "");
        }
        const thanksIndex = lines.findIndex((line) =>
            line.toLowerCase().includes("thanks & regards")
        );
        if (thanksIndex > 0 && lines[thanksIndex - 1] !== "") {
            lines.splice(thanksIndex, 0, "");
        }
        const nameIndex = lines.findIndex(
            (line) => line.trim().toLowerCase() === "anil"
        );
        if (nameIndex > 0 && lines[nameIndex - 1] !== "") {
            lines.splice(nameIndex, 0, "");
        }
        plainText = lines.join("\n");

        const labels = selectedMail?.labels || childTaskData?.Email?.labels || getemailbyid?.labels;
        if (labels?.includes("SENT")) {
            formData.append("sentBy", receiverEmail);
            formData.append("sentTo", senderEmail);
        } else {
            formData.append("sentBy", senderEmail);
            formData.append("sentTo", receiverEmail);
        }

        formData.append("subject", subject);
        formData.append("gmailMessageId", gmailMessageId);
        formData.append("body", plainText.trim());
        formData.append("cc", cc || "");
        formData.append("bcc", bcc || "");
        formData.append("gmailUserId", gmailUserId || "");
        formData.append('parentTaskID', TaskId)
        uploadedFiles.forEach((file) => {
            formData.append("attachments", file);
        });

        return formData;
    };

    const saveDraft = async () => {
        try {
            const formData = buildDraftFormData();
            const res = await services.draft.CREATE_DRAFT(formData);
            setSaveDrafts("Draft saved");
            setTimeout(() => setSaveDrafts(""), 3000);
            setDraftId(res?.data?.data?.id);
        } catch (e) {
            console.error("Draft create failed", e);
            setDraftStatus("Failed to save draft");
        }
    };

    const updateDraft = async () => {
        try {
            const formData = buildDraftFormData();
            formData.append("draftId", draftId);

            await services.draft.UPDATE_DRAFT(draftId, formData);
            setSaveDrafts("Draft saved");
            setTimeout(() => setSaveDrafts(""), 3000);

        } catch (e) {
            console.error("Draft update failed", e);
            setDraftStatus("Failed to update draft");
        }
    };

    useEffect(() => {
        if (replyDropdown1 || replyDropdown2 || replyDropdown3) {
            if (textAreaValue && textAreaValue?.length == 0) return;
            const delay = setTimeout(() => {
                if (draftId || draftStatus) {
                    updateDraft();
                } else {
                    saveDraft();
                }
            }, 2000);

            return () => clearTimeout(delay);
        }
    }, [textAreaValue]);

    useEffect(() => {
        const query = new URLSearchParams(location.search);
        const encodedProps = query.get('props');
        if (encodedProps) {
            const decodedProps = decodeURIComponent(encodedProps);
            const parsedProps = JSON.parse(decodedProps);
            linkData(parsedProps?.linkId);
        }
    }, [location.search]);

    const linkData = async (linkId) => {
        try {
            const response = await services.task.GET_TASK_LINK_DATA(linkId);
            const data = response?.data?.data;
            if (data) {
                setSelectedUserId(data?.task?.userId);
                getUserById(data?.task?.userId);
                getemailbyid(data?.task?.id);
                setCurrentTask(data?.task);
            }
        } catch (error) { }
    };
    const getUserById = async (userId) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/auth/getAllUser`);
            if (response?.data?.data?.users) {
                const user = response.data.data.users.find((u) => u.id === userId);
                if (user) {
                    setAssignedUserName(user.name);
                }
            }
        } catch (error) {
            console.error('Error fetching user:', error);
        }
    };
    useEffect(() => {
        if (location.state) {
            getUserById(location.state.selectedMail.userId);
        }
    }, [location.state]);


    const getDraftwithGmailMsgId = async () => {
        try {
            const response = await services.draft.GET_BY_GMAILMSGID(selectedMail?.gmailMessageId)
            setDraftId(response?.data?.data?.id)
            setReplyDropdown(true);
            setDraftStatus(true)
            setTextAreaValue(response?.data?.data?.body)

        } catch (error) {
            console.error(error)
        }
    }
    useEffect(() => {
        getDraftwithGmailMsgId();
    }, [selectedMail])

    useEffect(() => {
        getTaskAssign();
    }, [searchTerm]);

    const [isReplyloading, setIsReplyLoading] = useState(false);
    const createTask = async () => {
        setUploadedFiles([]);
        setIsReplyLoading(true);

        const { gmailMessageId, sentBy, sentTo, Email, subject } =
            selectedMail == null ? childTaskData : selectedMail || getemailbyid || childTaskData?.Email;

        const selecteMailUserId = selectedEmailId ? selectedEmailId : gmailMessageId;

        const senderEmail = (
            (sentTo && sentTo.match(/<([^>]+)>/)?.[1]) ||
            Email?.sentTo?.match(/<([^>]+)>/)?.[1] ||
            sentTo ||
            Email?.sentTo
        )?.trim();

        const receiverEmail = (
            (sentBy && sentBy.match(/<([^>]+)>/)?.[1]) ||
            Email?.sentBy?.match(/<([^>]+)>/)?.[1] ||
            sentBy ||
            Email?.sentBy
        )?.trim();

        if (senderEmail && receiverEmail) {
            const decodedHTML = textAreaValue
                .replace(/&lt;/g, '<')
                .replace(/&gt;/g, '>')
                .replace(/&nbsp;/gi, ' ')
                .replace(/&amp;/gi, '&');

            let plainText = decodedHTML
                .replace(/<p[^>]*>/gi, '')
                .replace(/<\/p>/gi, '\n')
                .replace(/\r\n|\r/g, '\n')
                .split('\n')
                .map((line) => line.trim())
                .filter((line) => line.length > 0)
                .join('\n');

            let lines = plainText.split('\n');
            if (lines.length > 1 && lines[0].trim() !== '') {
                lines.splice(1, 0, '');
            }

            const thanksIndex = lines.findIndex((line) => line.toLowerCase().includes('thanks & regards'));
            if (thanksIndex > 0 && lines[thanksIndex - 1] !== '') {
                lines.splice(thanksIndex, 0, '');
            }

            const anilIndex = lines.findIndex((line) => line.trim().toLowerCase() === 'anil');
            if (anilIndex > 0 && lines[anilIndex - 1] !== '') {
                lines.splice(anilIndex, 0, '');
            }
            plainText = lines.join('\n');
            const formData = new FormData();
            const labels = selectedMail?.labels || childTaskData?.Email?.labels || getemailbyid?.labels;

            if (labels?.includes('SENT')) {
                formData.append('sender', receiverEmail);
                formData.append('receiver', isReply == true || isForward == true ? emailValue : senderEmail);
            } else {
                formData.append('sender', senderEmail);
                formData.append('receiver', isReply == true || isForward == true ? emailValue : receiverEmail);
            }
            let text = '';
            if (isForward) {
                text = 'Fwd'
            } else {
                text = 'Re'
            }
            formData.append('messageId', gmailMessageId);
            formData.append('body', plainText.trim());
            formData.append('subject', `${text}: ${subject}`);
            formData.append('cc', cc || '');
            formData.append('bcc', bcc || '');
            uploadedFiles.forEach((file) => {
                formData.append('attachments', file);
            });

            try {
                let response;
                if (isForward) {
                    response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/email/forward/${selecteMailUserId}`, formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                            }
                        }
                    )
                    toast.success('Email forward successfully')
                } else {
                    response = await axios.post(
                        `${process.env.REACT_APP_BACKEND_URL}/email/reply/${selecteMailUserId}`,
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                            },
                        },
                    );
                    toast.success('Reply send successfully')
                }
                if (response) {
                    setReplyDropdown(false);
                    setReplyDropdown1(false);
                    setReplyDropdown2(false);
                    setReplyDropdown3(false);
                    handlegetEmailDetails(selecteMailUserId);
                    setTextAreaValue('');
                    dispatch(emailReply());
                    setTemplateselect([]);

                }
                if (draftId) {
                    await services.draft.DELETE_BY_ID_DRAFT(draftId)
                }
            } catch (error) {
                toast?.error(error?.response?.data?.error);
            } finally {
                setIsReplyLoading(false);
            }
        }
    };


    const updateTaskMail = async (id, deadlineData) => {
        const msgId = selectedMail?.gmailMessageId;
        const data = {
            deadline: deadlineData,
            gmailMessageId: msgId,
            userId: selectedUserId,
        };

        try {
            const response = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/task/updateTask/${id}`, data);
            if (response) {
                getTaskAssign();
            }
        } catch (error) {
            console.error('Error fetching task emails:', error);
        }
    };

    const getTemplate = async () => {
        try {
            const response = await services.template.GET_ALL_TEMPLATE();
            if (response) {
                setAllTemp(
                    response &&
                    response.length > 0 &&
                    response
                        .filter((item) => item.status === true)
                        .map((item) => ({
                            label: item?.name,
                            value: item?.body,
                            displayValue: item?.body.replace(/\n/g, ' '),
                        })),
                );
            }
        } catch (e) {
            console.error(e);
        }
    };
    useEffect(() => {
        getTemplate();
    }, []);

    // const decodeHtml = (html) => {
    //     const txt = document.createElement('textarea');
    //     txt.innerHTML = html;
    //     return txt.value;
    // };

    useEffect(() => {
        if (selectedMail && location?.state?.clickMailTask) {
            let Arr = [];

            Arr.push(selectedMail);

            if (selectedMail.SubTasks && selectedMail.SubTasks.length > 0) {
                Arr.push(...selectedMail?.SubTasks);
            }
            setThread(Arr?.length > 0 && Arr[0]?.id);
            setAllThreadTask(Arr);
            // Reset expanded thread when mail changes
            setExpandedThreadIndex(null);
        }
    }, [selectedMail]);

    // if (loading) {
    //     return <Loading />;
    // }

    const handleRemoveFile = (index) => {
        setUploadedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    };

    const [showAllReplies, setShowAllReplies] = useState(false);

    const visibleReplies = showAllReplies ? formattedBody : formattedBody?.slice(-2);

    const hiddenRepliesCount = formattedBody?.length - 2;

    function formatEmailBody(body) {
        if (!body) return '';
        // Replace line breaks with <br>
        return body.replace(/(?:\r\n|\r|\n)/g, '<br/>');
    }

    function renderThread(threadArr, level = 0) {
        if (!threadArr || threadArr.length === 0) return null;
        return threadArr.map((item, idx) => (
            <div
                key={item.id || idx}
                style={{
                    marginLeft: level * 24,
                    borderLeft: level ? '2px solid #eee' : 'none',
                    paddingLeft: 12,
                    marginTop: 8,
                    marginBottom: 8,
                }}
            >
                <div className="text-xs text-gray-500 mb-1">
                    {item.sender} &lt;{item.receiver}&gt; — {moment(item.createdAt).format('MMM D, YYYY, h:mm A')}
                </div>
                <div
                    className="text-[15px] text-gray-700 mb-2"
                    dangerouslySetInnerHTML={{ __html: item.body.replace(/\r\n|\r|\n/g, '<br/>') }}
                />
            </div>
        ));
    }

    const formatMailBody = (body) => {
        if (!body) return '';

        let cleanBody = body.replace(/(\r\n|\r|\n|>{1,2}\s?)/g, '<br/>');
        cleanBody = cleanBody.replace(/(<br\/?>\s*){2,}/gi, '<br/>');

        const pattern = /(On .*wrote:)/gi;
        cleanBody = cleanBody.replace(
            pattern,
            `<span style="font-size:13px;">$1</span><div style="margin-left:12px;">`,
        );

        cleanBody = cleanBody.replace(/(<br\/?>)((?:&gt;)+)([^<]*)/g,
            (match, br, gt, text) => `<br/><blockquote>${text}</blockquote>`
        );

        cleanBody = cleanBody.replace(/(---------- Forwarded message ---------)/g,
            `<br/>$1`
        );
        // cleanBody = cleanBody.replace(/From:([^<br]*)/g,
        //     `<br/>From:$1`
        // );
        // cleanBody = cleanBody.replace(/Subject:([^<br]*)/g,
        //     `<br/>Subject:$1`
        // );
        // cleanBody = cleanBody.replace(/To:([^<br]*)/g,
        //     `<br/>To:$1`
        // );
        cleanBody = cleanBody.replace(/Date:([^<br]*)/g,
            `<br/>Date:$1`
        );
        cleanBody = cleanBody.replace(/Cc:([^<br]*)/g,
            `<br/>Cc:$1`
        );
        cleanBody = cleanBody.replace(/(To:[^\n<]*([\s\S]*?))(<br\/?>|$)/g, (match, toLine, extra, ending) => {
            return `${toLine}${ending}<br/><br/>`;
        });


        if (!cleanBody.endsWith('</div>')) cleanBody += '</div>';

        return cleanBody;
    };

    const processMailBody = (body) => {
        if (!body) return { main: '', rest: '', count: 0 };

        const pattern = /On[\s\S]*?wrote:/gi;
        const matches = body.match(pattern);
        const count = matches ? matches.length : 0;

        const format = (text) => {
            if (!text) return '';
            let cleanBody = text.replace(/(\r\n|\r|\n|>{1,2}\s?)/g, '<br/>');
            cleanBody = cleanBody.replace(/(<br\/?>\s*){2,}/gi, '<br/>');

            cleanBody = cleanBody.replace(
                pattern,
                `<br/><span style="font-size:13px;color:#555;">$&</span><div style="margin-left:12px;border-left:1px solid #dfdfdf;padding-left:12px;">`,
            );

            cleanBody = cleanBody.replace(/(<br\/?>)((?:&gt;|>)+)([^<]*)/g, (match, br, gt, text) => {
                const depth = (gt.match(/&gt;|>/g) || []).length;
                let opening = br;
                for (let i = 0; i < depth; i++) {
                    opening += '<blockquote>';
                }
                return opening + text + '</blockquote>'.repeat(depth);
            });

            cleanBody = cleanBody.replace(/(---------- Forwarded message ---------)/g,
                `<br/>$1`
            );
            cleanBody = cleanBody.replace(/Date:([^<br]*)/g,
                `Date:$1`
            );
            cleanBody = cleanBody.replace(/Cc:([^<br]*)/g,
                `Cc:$1`
            );
            cleanBody = cleanBody.replace(/From:([^<br]*)/g,
                `<br/>From:$1`
            );
            cleanBody = cleanBody.replace(/Subject:([^<br]*)/g,
                `<br/>Subject:$1`
            );
            cleanBody = cleanBody.replace(/To:([^<br]*)/g,
                `<br/>To:$1`
            );

            if (!cleanBody.endsWith('</div>')) cleanBody += '</div>';

            return cleanBody;
        };

        if (count <= 1) {
            return { main: format(body), rest: '', count };
        }

        const firstMatchIndex = body.search(pattern);
        const mainPart = body.slice(0, firstMatchIndex).trim();
        const restPart = body.slice(firstMatchIndex).trim();

        return { main: format(mainPart), rest: format(restPart), count };
    };

    const MAX_IMAGES = 3;

    const handleFileChange = (e) => {
        if (e.target.files) {
            const newFiles = Array.from(e.target.files);
            if (uploadedFiles.length + newFiles.length > MAX_IMAGES) {
                toast.error(`You can only select up to ${MAX_IMAGES} images.`);
                return;
            }
            setUploadedFiles((prev) => [...prev, ...newFiles]);
        }
    };

    const lastReplyBody = visibleReplies?.length > 0
        ? visibleReplies[visibleReplies?.length - 1]
        : "";

    const handleReplyAll = (item = null, mode = 'replyAll', idx = null) => {
        setExpandreplyVisible(idx)
        setIsReply(false);
        // setReplyDropdown(true);
        setIsForward(false);
        if (mode === 'replyAll') {
            setIsreplyAll(true);
            setIsvisible(false);
            setReplyDropdown1(!replyDropdown1)
            setReplyDropdown2(false)
            setReplyDropdown3(false)
        } else if (mode === 'visible') {
            setIsvisible(true);
            setIsreplyAll(false);
            // setReplyDropdown2((prev) => {
            //     const newState = [...prev];
            //     if (idx !== null && idx >= 0) {
            //         newState[idx] = !newState[idx];
            //     }
            //     return newState;
            // });
            setReplyDropdown2(!replyDropdown2)
            setReplyDropdown1(false)
            setReplyDropdown3(false)
        } else if (mode === '-') {
            setReplyDropdown3(!replyDropdown3)
            setReplyDropdown1(false)
            setReplyDropdown2(false)
        }
        const userData = JSON.parse(localStorage.getItem("userData") || "{}");
        const currentUserEmail = userData?.email || "";
        const extractEmails = (str) => {
            if (!str) return [];
            return str.match(/[\w.-]+@[\w.-]+\.[A-Za-z]{2,}/g) || [];
        };

        let setReply;

        if (mode === 'replyAll') {
            setReply = selectedMail || selectedMail?.Email || childTaskData?.Email;
        } else if (mode === 'visible') {
            setReply = item;
        } else if (mode === '-') {
            setReply = lastReplyBody || selectedMail|| selectedMail?.Email || childTaskData?.Email;
        } else {
            setReply = selectedMail|| selectedMail?.Email || childTaskData?.Email;
        }

        const toRecipients = extractEmails(setReply?.sentTo || setReply?.receiver)
            .filter(r => r !== currentUserEmail);
        const ccRecipients = extractEmails(setReply?.cc)
            .filter(r => r !== currentUserEmail);
        // const bccRecipients = extractEmails(setReply?.bcc)
        //     .filter(r => r !== currentUserEmail);

        setEmailValue(toRecipients.join(', '));
        setCc(ccRecipients.join(', '));
        // setBcc(bccRecipients.join(', '));

        setShowCc(!!ccRecipients.length);
        // setShowBcc(!showBcc);
    };

    React.useEffect(() => {
        if (!replyDropdown) {
            setShowCc(false);
            setShowBcc(false);
            setShowBccCc(false);
        }
    }, [replyDropdown]);



    const hasSubEmailCcBcc = (selectedMail?.SubEmails || getemailbyid?.SubEmails || childTaskData?.Email?.SubEmails || []).some(
        (sub) => (sub.cc && sub.cc.trim() !== "") || (sub.bcc && sub.bcc.trim() !== "")
    );

    const shouldShowReplyAll =
        hasSubEmailCcBcc ||
        !!selectedMail?.cc ||
        !!getemailbyid?.cc ||
        !!childTaskData?.Email?.cc ||
        !!selectedMail?.bcc ||
        !!getemailbyid?.bcc ||
        !!childTaskData?.Email?.bcc;


    return (
        <div
            className="flex flex-col md:flex-row  overflow-hidden"
            style={{
                boxShadow: ' rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;',
            }}
        >
            <div className=" overflow-x-hidden overflow-y-scroll max-h-[100vh]" style={{ width: '100%' }}>
                <div className="bg-white rounded-md shadow-md p-2 md:p-4 ">
                    <div className="flex items-center gap-2 md:!gap-[1.5vw] px-2 py-1  bg-white"></div>
                    <div className="relative">
                        <div className="grid grid-cols-1 gap-x-[15px]">
                            <div className="relative bg-[#fff]">
                                <div style={{ display: 'flex', justifyContent: 'end' }}>
                                    {composeStatus && (
                                        <ComposeEmail
                                            replyDropdown={composeStatus}
                                            subject={dataById?.subject}
                                            selectedMail={location?.state?.selectedMail}
                                            setComposeStatus={setComposeStatus}
                                            setLoading={setLoading}
                                            attachmentPaths={attachmentPaths}
                                        />
                                    )}
                                </div>

                                {selectedMail?.Email || childTaskData?.Email || getemailbyid ? (
                                    <>
                                        {' '}
                                        <div className="">
                                            <div className="mail-inBox-header">
                                                <div className="flex flex-col  md:flex-row md:px-[0.5vw] justify-between items-start md:items-center">
                                                    <div>
                                                        <div className="text-[21px] md:pl-[1.5vw] md:ml-[1.2vw] text-gray-700">
                                                            {getemailbyid?.subject || childTaskData?.Email?.subject}
                                                            <span className=" text-xl  font-bold mt-[40px] text-black text-[1.375rem] "></span>
                                                            &nbsp;
                                                            {/* <button className="inline-flex bg-[#DDDDDD]   ml-[10px] rounded-[3px]">
                                                        <span className=" text-[.75rem] p-[2px_5px_1px]">Inbox x</span>
                                                    </button> */}
                                                            {/* <button className="inline-flex bg-[#DDDDDD]    ml-[10px] rounded-[3px]">
                                                        <span className=" text-[.75rem] p-[2px_5px_1px]">
                                                            - Shared/Project Board
                                                        </span>
                                                    </button> */}
                                                        </div>
                                                    </div>
                                                    {/* <div className="self-start flex items-center gap-2">
                                                <span className="p-[6px] hover:bg-[#E4E4E4] rounded-[50%]">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="16"
                                                        height="16"
                                                        fill="currentColor"
                                                        className="bi bi-chevron-expand"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path
                                                            fill-rule="evenodd"
                                                            d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708m0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708"
                                                        />
                                                    </svg>
                                                </span>
                                                <span className="p-[6px] hover:bg-[#E4E4E4] rounded-[50%]">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="20"
                                                        height="20"
                                                        fill="currentColor"
                                                        className="bi bi-printer p-[1px]"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" />
                                                        <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1" />
                                                    </svg>
                                                </span>
                                                <span className="p-[6px] hover:bg-[#E4E4E4] rounded-[50%]">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="18"
                                                        height="18"
                                                        fill="currentColor"
                                                        className="bi bi-box-arrow-up-right p-[1px]"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5" />
                                                        <path d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z" />
                                                    </svg>
                                                </span>
                                            </div> */}
                                                </div>
                                            </div>

                                            <div className="conversation-box relative bg-white py-3 md:py-5">
                                                <div className="flex flex-col gap-2">
                                                    <div className="flex items-start justify-between w-full">
                                                        <div className="flex items-start gap-3">
                                                            <div className="w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center text-gray-500 text-xl font-bold">
                                                                {selectedMail?.name?.charAt(0)?.toUpperCase() ||
                                                                    getemailbyid?.name?.charAt(0)?.toUpperCase() ||
                                                                    childTaskData?.Email?.name
                                                                        ?.charAt(0)
                                                                        ?.toUpperCase()}
                                                            </div>
                                                            <div className="flex flex-col items-start gap-y-[0.3vw]">
                                                                {/* <span className="font-bold text-[16px]  text-gray-700 leading-tight">{selectedMail?.name || getemailbyid?.name}</span> */}
                                                                <span className="text-[13px] font-google text-gray-500 leading-tight">
                                                                    {selectedMail?.sentBy ||
                                                                        getemailbyid?.sentBy ||
                                                                        childTaskData?.Email?.sentBy}
                                                                </span>
                                                                <span className="text-[13px] font-google text-gray-500 leading-tight">
                                                                    {selectedMail?.sentTo || getemailbyid?.sentTo || childTaskData?.Email?.sentTo ? (
                                                                        <>
                                                                            <span className="md:pr-[0.5vw]">To</span>
                                                                            {selectedMail?.sentTo || getemailbyid?.sentTo || childTaskData?.Email?.sentTo}
                                                                        </>
                                                                    ) : null}



                                                                    {selectedMail?.cc || getemailbyid?.cc || childTaskData?.Email?.cc ? (
                                                                        <>
                                                                            , cc: {selectedMail?.cc || getemailbyid?.cc || childTaskData?.Email?.cc}
                                                                        </>
                                                                    ) : null}

                                                                    {selectedMail?.bcc || getemailbyid?.bcc || childTaskData?.Email?.bcc ? (
                                                                        <>
                                                                            , bcc: {selectedMail?.bcc || getemailbyid?.bcc || childTaskData?.Email?.bcc}
                                                                        </>
                                                                    ) : null}



                                                                </span>


                                                                {/* <div className="text-[15px] text-gray-700 mt-1 mb-0 pl-5">
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: formatEmailBody(
                                                                                selectedMail?.Email?.body ||
                                                                                getemailbyid?.body ||
                                                                                childTaskData?.Email?.body,
                                                                            ),
                                                                        }}
                                                                    />
                                                                </div> */}
                                                            </div>
                                                        </div>
                                                        <div className="text-[13px] text-gray-400 whitespace-nowrap mt-1 pr-2 flex items-center gap-2">
                                                            {moment(
                                                                selectedMail?.createdAt ||
                                                                getemailbyid?.createdAt ||
                                                                childTaskData?.Email?.createdAt,
                                                            ).format('MMM D, YYYY, h:mm A')}
                                                            {/* Star icon */}
                                                            {/* <span className="p-1 rounded-full hover:bg-gray-100" title="Star">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="#444" strokeWidth="1.5" viewBox="0 0 24 24">
                                                            <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" strokeLinejoin="round" />
                                                        </svg>
                                                    </span> */}
                                                            {/* Smiley icon */}
                                                            {/* <span className="p-1 rounded-full hover:bg-gray-100" title="Emoji">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="#444" strokeWidth="1.5" viewBox="0 0 24 24">
                                                            <circle cx="12" cy="12" r="10" />
                                                            <path d="M8 15s1.5 2 4 2 4-2 4-2" />
                                                            <path d="M9 9h.01" />
                                                            <path d="M15 9h.01" />
                                                        </svg>
                                                    </span> */}
                                                            {/* Reply icon */}
                                                            <span
                                                                className="p-1 rounded-full hover:bg-gray-100"
                                                                title="Reply"
                                                                onClick={() => { handlereply('replyAll') }}
                                                            >
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="18"
                                                                    height="18"
                                                                    fill="none"
                                                                    stroke="#444"
                                                                    strokeWidth="1.5"
                                                                    viewBox="0 0 24 24"
                                                                >
                                                                    <path
                                                                        d="M10 19l-7-7 7-7"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    />
                                                                    <path
                                                                        d="M3 12h13a6 6 0 0 1 6 6v1"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    />
                                                                </svg>
                                                            </span>
                                                            <span
                                                                className="p-1 rounded-full hover:bg-gray-100 relative more-options-container"
                                                                title="More options"
                                                                onClick={() => setShowMoreOptions(!showMoreOptions)}
                                                            >
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="#444" strokeWidth="1.5" viewBox="0 0 24 24">
                                                                    <circle cx="12" cy="5" r="1.5" />
                                                                    <circle cx="12" cy="12" r="1.5" />
                                                                    <circle cx="12" cy="19" r="1.5" />
                                                                </svg>

                                                                {showMoreOptions && (
                                                                    <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-50 border border-gray-200">
                                                                        <div className="py-1">
                                                                            <button
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    handlereply('replyAll');
                                                                                    setShowMoreOptions(false);

                                                                                }}
                                                                                className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                                                            >
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24" className="mr-3">
                                                                                    <path d="M10 19l-7-7 7-7M3 12h13a6 6 0 0 1 6 6v1" strokeLinecap="round" strokeLinejoin="round" />
                                                                                </svg>
                                                                                Reply
                                                                            </button>
                                                                            {shouldShowReplyAll ? <button
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    setIsreplyAll(true);
                                                                                    handleReplyAll(null, 'replyAll');
                                                                                    setShowMoreOptions(false);
                                                                                }}
                                                                                className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 h-4"
                                                                            >
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24" className="mr-3">
                                                                                    <path d="M7 19l-7-7 7-7M3 12h13a6 6 0 0 1 6 6v1M13 19l-7-7 7-7" strokeLinecap="round" strokeLinejoin="round" />
                                                                                </svg>
                                                                                Reply all
                                                                            </button> : null}


                                                                            <button
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    handleForward('replyAll');
                                                                                    setShowMoreOptions(false);
                                                                                }}
                                                                                className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                                                            >
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24" className="mr-3">
                                                                                    <path d="M14 5l7 7-7 7M21 12H8a6 6 0 0 0-6 6v1" strokeLinecap="round" strokeLinejoin="round" />
                                                                                </svg>
                                                                                Forward
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </span>
                                                            {/* More/vertical dots icon */}
                                                            {/* <button className="p-1 rounded-full hover:bg-gray-100" title="More">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="#444" strokeWidth="1.5" viewBox="0 0 24 24">
                                                            <circle cx="12" cy="5" r="1.5" />
                                                            <circle cx="12" cy="12" r="1.5" />
                                                            <circle cx="12" cy="19" r="1.5" />
                                                        </svg>
                                                    </button> */}
                                                        </div>
                                                    </div>
                                                    {/* <div className="text-[15px] text-gray-700 mt-1 mb-0 pl-5"> */}
                                                    <div
                                                        className="text-[15px] text-gray-700 mt-1 mb-0 pl-0"
                                                        style={{ padding: '0 4.25rem' }}
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                                selectedMail?.Email?.body ||
                                                                getemailbyid?.body ||
                                                                childTaskData?.Email?.body ||
                                                                '',
                                                        }}
                                                    />
                                                    {/* </div> */}
                                                    {/* <div className="border-b-1 md:pl-[1.2vw] flex flex-col md:flex-row items-start md:items-center gap-2 text-[13px] opacity-50 text-black ">
                                        <p className="mt-[-20px] ">
                                            {selectedMail?.sentTo || getemailbyid?.sentTo}
                                        </p>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="14"
                                            height="14"
                                            fill="currentColor"
                                            className="bi bi-caret-down-fill mt-[-17px]"
                                            viewBox="0 0 16 16"
                                        >
                                            <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                        </svg>
                                    </div> */}
                                                    {!replyDropdown1 && !isReplyloading && !isreplyAll ? // <Loading />
                                                        null : (
                                                            <ReplyDropdown
                                                                emailValue={emailValue}
                                                                cc={cc}
                                                                bcc={bcc}
                                                                showCc={showCc}
                                                                showBcc={showBcc}
                                                                setEmailValue={setEmailValue}
                                                                setCc={setCc}
                                                                setBcc={setBcc}
                                                                setShowCc={setShowCc}
                                                                setShowBcc={setShowBcc}
                                                                handleEmailChange={handleEmailChange}
                                                                handleCcChange={handleCcChange}
                                                                handleBccChange={handleBccChange}
                                                                replyDropdown={replyDropdown1}
                                                                setReplyDropdown={setReplyDropdown1}
                                                                isForward={isForward}
                                                                isReply={isReply}
                                                                templateselect={templateselect}
                                                                setTemplateselect={setTemplateselect}
                                                                allTemp={allTemp}
                                                                template={template}
                                                                setTemplate={setTemplate}
                                                                textAreaValue={textAreaValue}
                                                                setTextAreaValue={setTextAreaValue}
                                                                visibleReplies={visibleReplies}
                                                                selectedMail={selectedMail}
                                                                isReplyloading={isReplyloading}
                                                                createTask={createTask}
                                                                handleFileChange={handleFileChange}
                                                                uploadedFiles={uploadedFiles}
                                                                handleRemoveFile={handleRemoveFile}
                                                                handleDelete={() => handleDelete('replyAll')}
                                                                setShowBccCc={setShowBccCc}
                                                                getemailbyid={getemailbyid}
                                                                childTaskData={childTaskData}
                                                                mode='replyAll'
                                                                saveDrafts={saveDrafts}
                                                                submitData={submitData}
                                                                setSubmitData={setSubmitData}
                                                            />

                                                        )}
                                                </div>
                                                {/* <div dangerouslySetInnerHTML={{ __html: selectedMail?.Email?.body }}></div> */}

                                                <div className="py-0">
                                                    <div className="max-w-screen-sm leading-8 text-black bg-[transparent]">
                                                        {attachmentPaths.attachmentPaths &&
                                                            attachmentPaths.attachmentPaths.length > 0 && (
                                                                <div
                                                                    className="gmail-attachment-list"
                                                                    style={{ padding: '0 4.25rem' }}
                                                                >
                                                                    {attachmentPaths.attachmentPaths.map(
                                                                        (file, attIdx) => {
                                                                            const fileUrl = `${process.env.REACT_APP_IMAGE_URL || ''
                                                                                }/${file}`;
                                                                            return (
                                                                                <div
                                                                                    className="gmail-attachment-card"
                                                                                    key={attIdx}
                                                                                >
                                                                                    {/\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(
                                                                                        file,
                                                                                    ) ? (
                                                                                        <a
                                                                                            href={fileUrl}
                                                                                            target="_blank"
                                                                                            rel="noopener noreferrer"
                                                                                        >
                                                                                            <img
                                                                                                src={fileUrl}
                                                                                                alt={file}
                                                                                                style={{
                                                                                                    width: 120,
                                                                                                    height: 120,
                                                                                                    objectFit: 'cover',
                                                                                                    borderRadius: 8,
                                                                                                    border: '1px solid #eee',
                                                                                                }}
                                                                                            />
                                                                                        </a>
                                                                                    ) : (
                                                                                        // Otherwise, show a file icon
                                                                                        <div>
                                                                                            <div className="gmail-attachment-filename-url">
                                                                                                {(() => {
                                                                                                    const ext = file
                                                                                                        .split('.')
                                                                                                        .pop();
                                                                                                    const name =
                                                                                                        file.slice(
                                                                                                            0,
                                                                                                            -(
                                                                                                                ext.length +
                                                                                                                1
                                                                                                            ),
                                                                                                        );
                                                                                                    return name.length >
                                                                                                        10
                                                                                                        ? `${name.slice(
                                                                                                            0,
                                                                                                            10,
                                                                                                        )}... .${ext}`
                                                                                                        : file;
                                                                                                })()}
                                                                                            </div>
                                                                                            <div>
                                                                                                <div className="gmail-attachment-pdficon gap-2">
                                                                                                    <div>
                                                                                                        <svg
                                                                                                            width="32"
                                                                                                            height="32"
                                                                                                            viewBox="0 0 24 24"
                                                                                                            fill="none"
                                                                                                        >
                                                                                                            <rect
                                                                                                                width="24"
                                                                                                                height="24"
                                                                                                                rx="4"
                                                                                                                fill="#F44336"
                                                                                                            />
                                                                                                            <text
                                                                                                                x="6"
                                                                                                                y="17"
                                                                                                                fill="#fff"
                                                                                                                fontSize="10"
                                                                                                                fontWeight="bold"
                                                                                                            >
                                                                                                                {file
                                                                                                                    .split(
                                                                                                                        '.',
                                                                                                                    )
                                                                                                                    .pop()
                                                                                                                    .toUpperCase()}
                                                                                                            </text>
                                                                                                        </svg>
                                                                                                    </div>
                                                                                                    <div>
                                                                                                        <span className="gmail-attachment-filename">
                                                                                                            {' '}
                                                                                                            {(() => {
                                                                                                                const ext =
                                                                                                                    file
                                                                                                                        .split(
                                                                                                                            '.',
                                                                                                                        )
                                                                                                                        .pop();
                                                                                                                const name =
                                                                                                                    file.slice(
                                                                                                                        0,
                                                                                                                        -(
                                                                                                                            ext.length +
                                                                                                                            1
                                                                                                                        ),
                                                                                                                    );
                                                                                                                return name.length >
                                                                                                                    10
                                                                                                                    ? `${name.slice(
                                                                                                                        0,
                                                                                                                        10,
                                                                                                                    )}... .${ext}`
                                                                                                                    : file;
                                                                                                            })()}
                                                                                                        </span>
                                                                                                    </div>
                                                                                                    <div className="gmail-attachment-actions">
                                                                                                        <a
                                                                                                            href={
                                                                                                                fileUrl
                                                                                                            }
                                                                                                            download={
                                                                                                                file
                                                                                                            }
                                                                                                            target="_blank"
                                                                                                            rel="noopener noreferrer"
                                                                                                            className="gmail-attachment-action-btn"
                                                                                                            title="Download"
                                                                                                        >
                                                                                                            <svg
                                                                                                                width="20"
                                                                                                                height="20"
                                                                                                                fill="#555"
                                                                                                                viewBox="0 0 16 16"
                                                                                                            >
                                                                                                                <path d="M.5 9.9a.5.5 0 0 1 .5.5V13a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.6a.5.5 0 0 1 1 0V13a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.6a.5.5 0 0 1 .5-.5z" />
                                                                                                                <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                                                                                                            </svg>
                                                                                                        </a>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            );
                                                                        },
                                                                    )}
                                                                </div>
                                                            )}

                                                        {formattedBody?.length > 2 && (
                                                            <div
                                                                onClick={() => setShowAllReplies(!showAllReplies)}
                                                                className="relative   cursor-pointer"
                                                            >
                                                                {/* Circle with number + hover arrows */}
                                                                <div className="z-10 absolute bg-white border top-[-0.9vw] left-[0.5vw] border-gray-300 rounded-full w-8 h-8 flex items-center justify-center shadow-sm group-hover:bg-gray-100 transition duration-200">
                                                                    {/* Default count shown */}
                                                                    {!showAllReplies && (
                                                                        <span className="text-sm text-gray-700 font-medium group-hover:opacity-0 transition-opacity duration-200">
                                                                            {formattedBody.length - 2}
                                                                        </span>
                                                                    )}
                                                                    <hr />

                                                                    {/* Arrows shown only on hover */}
                                                                    <div className="absolute opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                                                                        {!showAllReplies ? (
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="14"
                                                                                height="14"
                                                                                fill="gray"
                                                                                viewBox="0 0 16 16"
                                                                            >
                                                                                <path d="M8 1.5a.5.5 0 0 1 .374.832l-3.5 4a.5.5 0 0 1-.748-.664l3.5-4A.5.5 0 0 1 8 1.5zm0 13a.5.5 0 0 1-.374-.832l3.5-4a.5.5 0 0 1 .748.664l-3.5 4A.5.5 0 0 1 8 14.5z" />
                                                                            </svg>
                                                                        ) : (
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="14"
                                                                                height="14"
                                                                                fill="gray"
                                                                                viewBox="0 0 16 16"
                                                                            >
                                                                                <path d="M1.5 10.5a.5.5 0 0 0 .832.374l4-3.5a.5.5 0 0 0-.664-.748l-4 3.5A.5.5 0 0 0 1.5 10.5zM14.5 10.5a.5.5 0 0 1-.832.374l-4-3.5a.5.5 0 0 1 .664-.748l4 3.5a.5.5 0 0 1 .168.374z" />
                                                                            </svg>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {visibleReplies &&
                                                            visibleReplies.length > 0 &&
                                                            visibleReplies.map((item, idx) => {
                                                                const { main, rest, count } = processMailBody(
                                                                    item.body,
                                                                );

                                                                return (
                                                                    <div key={idx} style={{ minHeight: '80px' }}>

                                                                        <hr />
                                                                        <div>
                                                                            <div className="flex items-start justify-between w-full mt-4">
                                                                                <div className="flex items-start gap-3">
                                                                                    <div className="w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center text-gray-500 text-xl font-bold">
                                                                                        {item?.sender
                                                                                            ?.charAt(0)
                                                                                            ?.toUpperCase()}
                                                                                    </div>
                                                                                    <div className="flex flex-col items-start gap-y-[0.3vw]">
                                                                                        <span className="text-[13px] font-google text-gray-500 leading-tight">
                                                                                            {item?.sender}


                                                                                            {selectedMail?.bcc || getemailbyid?.bcc || childTaskData?.Email?.bcc ? (
                                                                                                <>
                                                                                                    , bcc: {selectedMail?.bcc || getemailbyid?.bcc || childTaskData?.Email?.bcc}
                                                                                                </>
                                                                                            ) : null}
                                                                                        </span>
                                                                                        <span className="text-[13px] font-google text-gray-500 leading-tight">
                                                                                            <span className="md:pr-[0.5vw]">
                                                                                                To
                                                                                            </span>
                                                                                            {item?.receiver}
                                                                                            {item?.cc ? (
                                                                                                <>
                                                                                                    , cc: {item?.cc}
                                                                                                </>
                                                                                            ) : null}
                                                                                            {item?.bcc ? (
                                                                                                <>
                                                                                                    , bcc: {item?.bcc}
                                                                                                </>
                                                                                            ) : null}
                                                                                            { }
                                                                                        </span>
                                                                                        <div
                                                                                            className="text-[13px] text-gray-700 mt-1 mb-0 pl-0"
                                                                                            dangerouslySetInnerHTML={{
                                                                                                __html: formatMailBody(
                                                                                                    main,
                                                                                                ),
                                                                                            }}
                                                                                        />

                                                                                        {threadData &&
                                                                                            threadData.length > 0 &&
                                                                                            idx > 0 &&
                                                                                            count > 1 &&
                                                                                            expandedThreadIndex !== idx && (
                                                                                                <div
                                                                                                    className="cursor-pointer flex items-center gap-2"
                                                                                                    onClick={() =>
                                                                                                        setExpandedThreadIndex(
                                                                                                            idx,
                                                                                                        )
                                                                                                    }
                                                                                                    style={{
                                                                                                        margin: '10px 0',
                                                                                                    }}
                                                                                                >
                                                                                                    <span className="rounded-full bg-gray-200 px-3 py-1 text-gray-700">
                                                                                                        ...
                                                                                                    </span>
                                                                                                </div>
                                                                                            )}
                                                                                        {expandedThreadIndex === idx &&
                                                                                            threadData &&
                                                                                            threadData.length > 0 && (
                                                                                                <>
                                                                                                    <div
                                                                                                        className="gmail-thread text-[13px] text-gray-700 mt-1 mb-0 pl-0"
                                                                                                        dangerouslySetInnerHTML={{
                                                                                                            __html: formatMailBody(
                                                                                                                rest,
                                                                                                            ),
                                                                                                        }}
                                                                                                    />
                                                                                                    <button
                                                                                                        onClick={() =>
                                                                                                            setExpandedThreadIndex(
                                                                                                                null,
                                                                                                            )
                                                                                                        }
                                                                                                        className="text-blue-500 text-xs mt-2"
                                                                                                    >
                                                                                                        Show less
                                                                                                    </button>
                                                                                                </>
                                                                                            )}
                                                                                    </div>
                                                                                </div>
                                                                                <div className="text-[13px] text-gray-400 whitespace-nowrap mt-1 pr-2 flex items-center gap-2">
                                                                                    {moment(item?.createdAt)?.format(
                                                                                        'MMM D, YYYY, h:mm A',
                                                                                    )}
                                                                                    <span
                                                                                        className="p-1 rounded-full hover:bg-gray-100"
                                                                                        title="Reply"
                                                                                        onClick={() => { handlereply('visible', idx, item) }}
                                                                                    >
                                                                                        <svg
                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                            width="18"
                                                                                            height="18"
                                                                                            fill="none"
                                                                                            stroke="#444"
                                                                                            strokeWidth="1.5"
                                                                                            viewBox="0 0 24 24"
                                                                                        >
                                                                                            <path
                                                                                                d="M10 19l-7-7 7-7"
                                                                                                strokeLinecap="round"
                                                                                                strokeLinejoin="round"
                                                                                            />
                                                                                            <path
                                                                                                d="M3 12h13a6 6 0 0 1 6 6v1"
                                                                                                strokeLinecap="round"
                                                                                                strokeLinejoin="round"
                                                                                            />
                                                                                        </svg>
                                                                                    </span>

                                                                                    <span
                                                                                        ref={node => {
                                                                                            let clickedId = null;
                                                                                            if (item?.id) clickedId = `item-${item.id}`;
                                                                                            else if (selectedMail?.id) clickedId = `selectedMail-${selectedMail.id}`;
                                                                                            else if (childTaskData?.Email?.id) clickedId = `child-${childTaskData.Email.id}`;
                                                                                            else if (getemailbyid?.id) clickedId = `email-${getemailbyid.id}`;
                                                                                            if (clickedId) dropdownRefs.current[clickedId] = node;
                                                                                        }}
                                                                                        className="p-1 rounded-full hover:bg-gray-100 relative more-options-container m-3"
                                                                                        title="More options"
                                                                                        onClick={(e) => {
                                                                                            e.stopPropagation();

                                                                                            let clickedId = null;

                                                                                            if (item?.id) clickedId = `item-${item.id}`;
                                                                                            else if (selectedMail?.id) clickedId = `selectedMail-${selectedMail.id}`;
                                                                                            else if (childTaskData?.Email?.id) clickedId = `child-${childTaskData.Email.id}`;
                                                                                            else if (getemailbyid?.id) clickedId = `email-${getemailbyid.id}`;

                                                                                            if (openModalId === clickedId) {
                                                                                                setOpenModalId(null); // same id -> close
                                                                                            } else {
                                                                                                setOpenModalId(clickedId); // unique id set
                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="#444" strokeWidth="1.5" viewBox="0 0 24 24">
                                                                                            <circle cx="12" cy="5" r="1.5" />
                                                                                            <circle cx="12" cy="12" r="1.5" />
                                                                                            <circle cx="12" cy="19" r="1.5" />
                                                                                        </svg>

                                                                                        {(openModalId === `item-${item?.id}` ||
                                                                                            openModalId === `selectedMail-${selectedMail?.id}` ||
                                                                                            openModalId === `child-${childTaskData?.Email?.id}` ||
                                                                                            openModalId === `email-${getemailbyid?.id}`) && (
                                                                                                <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-50 border border-gray-200">
                                                                                                    <div className="py-1">
                                                                                                        <button
                                                                                                            onClick={(e) => {
                                                                                                                e.stopPropagation();
                                                                                                                handlereply('visible', idx, item);
                                                                                                                setOpenModalId(null);
                                                                                                            }}
                                                                                                            className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                                                                                        >
                                                                                                            Reply
                                                                                                        </button>
                                                                                                        {shouldShowReplyAll ? (
                                                                                                            <button
                                                                                                                onClick={(e) => {
                                                                                                                    e.stopPropagation();
                                                                                                                    setIsvisible(true)
                                                                                                                    handleReplyAll(item, 'visible', idx);
                                                                                                                    setOpenModalId(null);
                                                                                                                }}
                                                                                                                className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                                                                                            >
                                                                                                                Reply all
                                                                                                            </button>
                                                                                                        ) : (null)}
                                                                                                        <button
                                                                                                            onClick={(e) => {
                                                                                                                e.stopPropagation();
                                                                                                                handleForward('visible', idx);
                                                                                                                setOpenModalId(null);
                                                                                                            }}
                                                                                                            className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                                                                                        >
                                                                                                            Forward
                                                                                                        </button>
                                                                                                    </div>
                                                                                                </div>
                                                                                            )}
                                                                                    </span>




                                                                                </div>


                                                                            </div>

                                                                            {expandreplyVisible !== idx ? // <Loading />
                                                                                null : (
                                                                                    <ReplyDropdown
                                                                                        emailValue={emailValue}
                                                                                        cc={cc}
                                                                                        bcc={bcc}
                                                                                        showCc={showCc}
                                                                                        showBcc={showBcc}
                                                                                        setEmailValue={setEmailValue}
                                                                                        setCc={setCc}
                                                                                        setBcc={setBcc}
                                                                                        setShowCc={setShowCc}
                                                                                        setShowBcc={setShowBcc}
                                                                                        handleEmailChange={handleEmailChange}
                                                                                        handleCcChange={handleCcChange}
                                                                                        handleBccChange={handleBccChange}
                                                                                        replyDropdown={replyDropdown2}
                                                                                        setReplyDropdown={setReplyDropdown2}
                                                                                        isForward={isForward}
                                                                                        isReply={isReply}
                                                                                        templateselect={templateselect}
                                                                                        setTemplateselect={setTemplateselect}
                                                                                        allTemp={allTemp}
                                                                                        template={template}
                                                                                        setTemplate={setTemplate}
                                                                                        textAreaValue={textAreaValue}
                                                                                        setTextAreaValue={setTextAreaValue}
                                                                                        visibleReplies={visibleReplies}
                                                                                        selectedMail={selectedMail}
                                                                                        isReplyloading={isReplyloading}
                                                                                        createTask={createTask}
                                                                                        handleFileChange={handleFileChange}
                                                                                        uploadedFiles={uploadedFiles}
                                                                                        handleRemoveFile={handleRemoveFile}
                                                                                        handleDelete={() => handleDelete('visible', idx)}
                                                                                        setShowBccCc={setShowBccCc}
                                                                                        getemailbyid={getemailbyid}
                                                                                        childTaskData={childTaskData}
                                                                                        mode='visible'
                                                                                        idx={item?.id}
                                                                                        saveDrafts={saveDrafts}
                                                                                        submitData={submitData}
                                                                                        setSubmitData={setSubmitData}
                                                                                    />

                                                                                )}
                                                                        </div>
                                                                        {item.attachmentPaths &&
                                                                            item.attachmentPaths.length > 0 && (
                                                                                <div
                                                                                    className="gmail-attachment-list"
                                                                                    style={{ padding: '0 4.25rem' }}
                                                                                >
                                                                                    {item.attachmentPaths.map(
                                                                                        (file, attIdx) => {
                                                                                            const fileUrl = `${process.env
                                                                                                .REACT_APP_IMAGE_URL ||
                                                                                                ''
                                                                                                }/${file}`;
                                                                                            return (
                                                                                                <div
                                                                                                    className="gmail-attachment-card"
                                                                                                    key={attIdx}
                                                                                                >
                                                                                                    {/\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(
                                                                                                        file,
                                                                                                    ) ? (
                                                                                                        <a
                                                                                                            href={
                                                                                                                fileUrl
                                                                                                            }
                                                                                                            target="_blank"
                                                                                                            rel="noopener noreferrer"
                                                                                                        >
                                                                                                            <img
                                                                                                                src={
                                                                                                                    fileUrl
                                                                                                                }
                                                                                                                alt={
                                                                                                                    file
                                                                                                                }
                                                                                                                style={{
                                                                                                                    width: 120,
                                                                                                                    height: 120,
                                                                                                                    objectFit:
                                                                                                                        'cover',
                                                                                                                    borderRadius: 8,
                                                                                                                    border: '1px solid #eee',
                                                                                                                }}
                                                                                                            />
                                                                                                        </a>
                                                                                                    ) : (
                                                                                                        // Otherwise, show a file icon
                                                                                                        <div>
                                                                                                            <div className="gmail-attachment-filename-url">
                                                                                                                {(() => {
                                                                                                                    const ext =
                                                                                                                        file
                                                                                                                            .split(
                                                                                                                                '.',
                                                                                                                            )
                                                                                                                            .pop();
                                                                                                                    const name =
                                                                                                                        file.slice(
                                                                                                                            0,
                                                                                                                            -(
                                                                                                                                ext.length +
                                                                                                                                1
                                                                                                                            ),
                                                                                                                        );
                                                                                                                    return name.length >
                                                                                                                        10
                                                                                                                        ? `${name.slice(
                                                                                                                            0,
                                                                                                                            10,
                                                                                                                        )}... .${ext}`
                                                                                                                        : file;
                                                                                                                })()}
                                                                                                            </div>
                                                                                                            <div>
                                                                                                                <div className="gmail-attachment-pdficon gap-2">
                                                                                                                    <div>
                                                                                                                        <svg
                                                                                                                            width="32"
                                                                                                                            height="32"
                                                                                                                            viewBox="0 0 24 24"
                                                                                                                            fill="none"
                                                                                                                        >
                                                                                                                            <rect
                                                                                                                                width="24"
                                                                                                                                height="24"
                                                                                                                                rx="4"
                                                                                                                                fill="#F44336"
                                                                                                                            />
                                                                                                                            <text
                                                                                                                                x="6"
                                                                                                                                y="17"
                                                                                                                                fill="#fff"
                                                                                                                                fontSize="10"
                                                                                                                                fontWeight="bold"
                                                                                                                            >
                                                                                                                                {file
                                                                                                                                    .split(
                                                                                                                                        '.',
                                                                                                                                    )
                                                                                                                                    .pop()
                                                                                                                                    .toUpperCase()}
                                                                                                                            </text>
                                                                                                                        </svg>
                                                                                                                    </div>
                                                                                                                    <div>
                                                                                                                        <span className="gmail-attachment-filename">
                                                                                                                            {' '}
                                                                                                                            {(() => {
                                                                                                                                const ext =
                                                                                                                                    file
                                                                                                                                        .split(
                                                                                                                                            '.',
                                                                                                                                        )
                                                                                                                                        .pop();
                                                                                                                                const name =
                                                                                                                                    file.slice(
                                                                                                                                        0,
                                                                                                                                        -(
                                                                                                                                            ext.length +
                                                                                                                                            1
                                                                                                                                        ),
                                                                                                                                    );
                                                                                                                                return name.length >
                                                                                                                                    10
                                                                                                                                    ? `${name.slice(
                                                                                                                                        0,
                                                                                                                                        10,
                                                                                                                                    )}... .${ext}`
                                                                                                                                    : file;
                                                                                                                            })()}
                                                                                                                        </span>
                                                                                                                    </div>
                                                                                                                    <div className="gmail-attachment-actions">
                                                                                                                        <a
                                                                                                                            href={
                                                                                                                                fileUrl
                                                                                                                            }
                                                                                                                            download={
                                                                                                                                file
                                                                                                                            }
                                                                                                                            target="_blank"
                                                                                                                            rel="noopener noreferrer"
                                                                                                                            className="gmail-attachment-action-btn"
                                                                                                                            title="Download"
                                                                                                                        >
                                                                                                                            <svg
                                                                                                                                width="20"
                                                                                                                                height="20"
                                                                                                                                fill="#555"
                                                                                                                                viewBox="0 0 16 16"
                                                                                                                            >
                                                                                                                                <path d="M.5 9.9a.5.5 0 0 1 .5.5V13a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.6a.5.5 0 0 1 1 0V13a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.6a.5.5 0 0 1 .5-.5z" />
                                                                                                                                <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                                                                                                                            </svg>
                                                                                                                        </a>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    )}
                                                                                                </div>
                                                                                            );
                                                                                        },
                                                                                    )}
                                                                                </div>
                                                                            )}
                                                                    </div>
                                                                );
                                                            })}
                                                    </div>
                                                </div>
                                                {!replyDropdown3 && !isReplyloading && (
                                                    <div
                                                        style={{ marginBottom: '6.25rem' }}
                                                        className="flex flex-col md:flex-row gap-1 xl:gap-2 items-start justify-start mt-[25px]"
                                                    >
                                                        {/* <button
                                                onClick={handlereply}
                                                className="flex items-end justify-center text-black border text-[14px] gap-[5px] pb-[5px] pt-[4px] w-[150px] rounded-[30px] border-[#747775]"
                                            >
                                                <span className=" flex items-center gap-[15px]  text-[#000]">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="16"
                                                        height="16"
                                                        fill="currentColor"
                                                        className="bi bi-arrow-90deg-left "
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M1.146 4.854a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H12.5A2.5 2.5 0 0 1 15 6.5v8a.5.5 0 0 1-1 0v-8A1.5 1.5 0 0 0 12.5 5H2.707l3.147 3.146a.5.5 0 1 1-.708.708z" />
                                                    </svg>
                                                    Reply
                                                </span>
                                            </button> */}

                                                        <div
                                                            className="flex flex-row items-start
                             gap-3 md:pl-[2.5vw] mt-4"
                                                        >
                                                            {/* Reply Button */}
                                                            {/* {!replyDropdown && !isReplyloading && ( */}
                                                            <button
                                                                onClick={() => handlereply('-')}
                                                                className="flex items-center gap-2 px-5 py-2 rounded-full border border-gray-300 bg-white shadow-sm hover:bg-gray-100 text-gray-700 text-[15px] font-medium transition"
                                                                style={{ minWidth: 90 }}
                                                            >
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="20"
                                                                    height="20"
                                                                    fill="none"
                                                                    stroke="#444"
                                                                    strokeWidth="1.8"
                                                                    viewBox="0 0 24 24"
                                                                >
                                                                    <path
                                                                        d="M10 19l-7-7 7-7"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    />
                                                                    <path
                                                                        d="M3 12h13a6 6 0 0 1 6 6v1"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    />
                                                                </svg>
                                                                Reply
                                                            </button>

                                                            {shouldShowReplyAll ? (
                                                                <button
                                                                    onClick={() => handleReplyAll(null, '-')}
                                                                    className="flex items-center gap-2 px-5 py-2 rounded-full border border-gray-300 bg-white shadow-sm hover:bg-gray-100 text-gray-700 text-[15px] font-medium transition"
                                                                    style={{ minWidth: 90 }}
                                                                >
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        width="20"
                                                                        height="20"
                                                                        fill="none"
                                                                        stroke="#444"
                                                                        strokeWidth="1.8"
                                                                        viewBox="0 0 24 24"
                                                                    >
                                                                        <path
                                                                            d="M10 19l-7-7 7-7"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                        <path
                                                                            d="M3 12h13a6 6 0 0 1 6 6v1"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                    </svg>
                                                                    Reply all
                                                                </button>
                                                            ) : null}
                                                            {/* )} */}

                                                            {/* Forward Button */}
                                                            <button
                                                                onClick={() => handleForward('-')}
                                                                className="flex items-center gap-2 px-5 py-2 rounded-full border border-gray-300 bg-white shadow-sm hover:bg-gray-100 text-gray-700 text-[15px] font-medium transition"
                                                                style={{ minWidth: 110 }}
                                                            >
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" stroke="#444" strokeWidth="1.5" viewBox="0 0 24 24">
                                                                    <path d="M14 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
                                                                    <path d="M21 12H8a6 6 0 0 0-6 6v1" strokeLinecap="round" strokeLinejoin="round" />
                                                                </svg>
                                                                Forward
                                                            </button>
                                                            {/* Smiley Button */}
                                                            {/* <button
                                                    className="flex items-center justify-center px-4 py-2 rounded-full border border-gray-300 bg-white shadow-sm hover:bg-gray-100 text-gray-700 transition"
                                                    title="Add emoji"
                                                    style={{ minWidth: 44 }}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" stroke="#444" strokeWidth="1.5" viewBox="0 0 24 24">
                                                        <circle cx="12" cy="12" r="10" />
                                                        <path d="M8 15s1.5 2 4 2 4-2 4-2" />
                                                        <path d="M9 9h.01" />
                                                        <path d="M15 9h.01" />
                                                    </svg>
                                                </button> */}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div style={{ textAlign: 'center' }}>
                                            <span>Email Not Found</span>
                                        </div>
                                    </>
                                )}

                                {!replyDropdown3 && !isReplyloading ? // <Loading />
                                    null : (
                                        <ReplyDropdown
                                            emailValue={emailValue}
                                            cc={cc}
                                            bcc={bcc}
                                            showCc={showCc}
                                            showBcc={showBcc}
                                            setEmailValue={setEmailValue}
                                            setCc={setCc}
                                            setBcc={setBcc}
                                            setShowCc={setShowCc}
                                            setShowBcc={setShowBcc}
                                            handleEmailChange={handleEmailChange}
                                            handleCcChange={handleCcChange}
                                            handleBccChange={handleBccChange}
                                            replyDropdown={replyDropdown3}
                                            setReplyDropdown={setReplyDropdown3}
                                            isForward={isForward}
                                            isReply={isReply}
                                            templateselect={templateselect}
                                            setTemplateselect={setTemplateselect}
                                            allTemp={allTemp}
                                            template={template}
                                            setTemplate={setTemplate}
                                            textAreaValue={textAreaValue}
                                            setTextAreaValue={setTextAreaValue}
                                            visibleReplies={visibleReplies}
                                            selectedMail={selectedMail}
                                            isReplyloading={isReplyloading}
                                            createTask={createTask}
                                            handleFileChange={handleFileChange}
                                            uploadedFiles={uploadedFiles}
                                            handleRemoveFile={handleRemoveFile}
                                            handleDelete={() => handleDelete('-')}
                                            setShowBccCc={setShowBccCc}
                                            getemailbyid={getemailbyid}
                                            childTaskData={childTaskData}
                                            mode='-'
                                            saveDrafts={saveDrafts}
                                            submitData={submitData}
                                            setSubmitData={setSubmitData}
                                        />
                                    )}
                            </div>

                            {/* <div className="top-mail-border">
                                <div className="bg-white rounded-md p-4 mailbox-border ">
                                    <div className="flex flex-col md:flex-row justify-between mailbox-border-b">
                                        <div className="flex gap-[15px] md:gap-[30px] allspanitems">
                                            <span className=" hover:bg-[#E4E4E4] rounded-[50%]">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="20"
                                                    height="20"
                                                    fill="currentColor"
                                                    className="bi bi-check-circle p-[1px]"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                                    <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05" />
                                                </svg>
                                            </span>
                                            <span className="p-[6px] hover:bg-[#E4E4E4] rounded-[50%]">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="20"
                                                    height="20"
                                                    fill="currentColor"
                                                    className="bi bi-bell p-[1px]"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2M8 1.918l-.797.161A4 4 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4 4 0 0 0-3.203-3.92zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5 5 0 0 1 13 6c0 .88.32 4.2 1.22 6" />
                                                </svg>
                                            </span>
                                            <span className="p-[6px] hover:bg-[#E4E4E4] rounded-[50%]">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="20"
                                                    height="20"
                                                    fill="currentColor"
                                                    className="bi bi-calendar-date p-[1px]"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M6.445 11.688V6.354h-.633A13 13 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23" />
                                                    <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                                                </svg>
                                            </span>
                                            <span className=" hover:bg-[#E4E4E4] rounded-[50%]">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="20"
                                                    height="20"
                                                    fill="currentColor"
                                                    className="bi bi-flag p-[1px]"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M14.778.085A.5.5 0 0 1 15 .5V8a.5.5 0 0 1-.314.464L14.5 8l.186.464-.003.001-.006.003-.023.009a12 12 0 0 1-.397.15c-.264.095-.631.223-1.047.35-.816.252-1.879.523-2.71.523-.847 0-1.548-.28-2.158-.525l-.028-.01C7.68 8.71 7.14 8.5 6.5 8.5c-.7 0-1.638.23-2.437.477A20 20 0 0 0 3 9.342V15.5a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 1 0v.282c.226-.079.496-.17.79-.26C4.606.272 5.67 0 6.5 0c.84 0 1.524.277 2.121.519l.043.018C9.286.788 9.828 1 10.5 1c.7 0 1.638-.23 2.437-.477a20 20 0 0 0 1.349-.476l.019-.007.004-.002h.001M14 1.221c-.22.078-.48.167-.766.255-.81.252-1.872.523-2.734.523-.886 0-1.592-.286-2.203-.534l-.008-.003C7.662 1.21 7.139 1 6.5 1c-.669 0-1.606.229-2.415.478A21 21 0 0 0 3 1.845v6.433c.22-.078.48-.167.766-.255C4.576 7.77 5.638 7.5 6.5 7.5c.847 0 1.548.28 2.158.525l.028.01C9.32 8.29 9.86 8.5 10.5 8.5c.668 0 1.606-.229 2.415-.478A21 21 0 0 0 14 7.655V1.222z" />
                                                </svg>
                                            </span>
                                            <span className=" hover:bg-[#E4E4E4] rounded-[50%]">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="20"
                                                    height="20"
                                                    fill="currentColor"
                                                    className="bi bi-envelope p-[1px]"
                                                    viewBox="0 0 16 16"
                                                    onClick={() => setComposeStatus(!composeStatus)}
                                                >
                                                    <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 11.105zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741M1 11.105l4.708-2.897L1 5.383z" />
                                                </svg>
                                            </span>
                                            <span className=" hover:bg-[#E4E4E4] rounded-[50%]">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="20"
                                                    height="20"
                                                    fill="currentColor"
                                                    className="bi bi-paperclip p-[1px]"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0z" />
                                                </svg>
                                            </span>
                                        </div>
                                        <span className=" hover:bg-[#E4E4E4] rounded-[50%]">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="28"
                                                height="28"
                                                fill="currentColor"
                                                className="bi bi-arrow-right-short p-[1px]"
                                                viewBox="0 0 16 16"
                                            >
                                                <path d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8" />
                                            </svg>
                                        </span>
                                    </div>
                                    <div className="flex flex-col md:flex-row justify-between pb-[5px] border-b border-[#e0e0e0]">
                                        <h3 className="text-[1.2rem] font-bold text-black mt-[10px]">
                                            {dataById?.subject}
                                        </h3>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            fill="currentColor"
                                            className="bi bi-pencil mt-[15px] text-black"
                                            viewBox="0 0 16 16"
                                        >
                                            <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325" />
                                        </svg>
                                    </div>

                                    <div className="m-[8px_10px] md:m-[13px_15px]">
                                        <div className="relative inline-block text-left" style={{ width: '100%' }}>
                                            <FormControl fullWidth>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={thread}
                                                    onChange={(e) => {
                                                        setThread(e.target.value);
                                                    }}
                                                >
                                                    {allThreadTask &&
                                                        allThreadTask.length > 0 &&
                                                        allThreadTask.map((item, index) => (
                                                            <MenuItem
                                                                key={index}
                                                                value={item?.id}
                                                                onClick={() => {
                                                                    navigate(`/detail/${item?.id}`, {
                                                                        state: {
                                                                            selectedMail: item,
                                                                            deadlineDate: item?.deadline,
                                                                            taskID: item?.id,
                                                                        },
                                                                    });
                                                                }}
                                                            >
                                                                {item?.subject}
                                                            </MenuItem>
                                                        ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </div>
                                    <div className="flex flex-col md:flex-row mt-[15px] items-start md:items-center">
                                        <div className="border w-[35px] h-[34px] rounded-[50%] bg-[#F5F5F5] flex justify-center items-center self-start">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16"
                                                height="16"
                                                fill="currentColor"
                                                className="bi bi-person-circle"
                                                viewBox="0 0 16 16"
                                            >
                                                <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
                                                <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1" />
                                            </svg>
                                        </div>
                                        <div className="mb-2 ml-[5px] md:ml-[10px] w-[100%] flex svg-inputbox-relative">
                                            <textarea
                                                rows="4"
                                                cols="50"
                                                id="comments"
                                                placeholder="Add a comment"
                                                className="InputFieldOne emailinput textarea-comment  !w-[100%]"
                                            />
                                            <div className="svg-inputbox !top-[2px] !bottom-auto right-[13%]">
                                                <h6>@</h6>{' '}
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="16"
                                                    height="16"
                                                    fill="currentColor"
                                                    className="bi bi-telegram "
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.287 5.906q-1.168.486-4.666 2.01-.567.225-.595.442c-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294q.39.01.868-.32 3.269-2.206 3.374-2.23c.05-.012.12-.026.166.016s.042.12.037.141c-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8 8 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629q.14.092.27.187c.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.4 1.4 0 0 0-.013-.315.34.34 0 0 0-.114-.217.53.53 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09" />
                                                </svg>{' '}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MailInbox;
